import React from "react"
import styled from "styled-components"
import {
  Card,
  SectionTitle,
  CardV2,
  Badge,
  CLOUDFRONT,
  StatusText,
  StatusDiv,
  BadgeText,
  StatusMessage,
} from "../commonStyles"

const ComponentWrap = styled.div``

const Incomplete = () => (
  <ComponentWrap>
    <CardV2
      cardWidth="800px"
    >
      <StatusText>
        Status of the ICA
      </StatusText>
      <StatusDiv>
        <Badge
          bgColor="#A36809;"
        >
          <img src="https://s3.amazonaws.com/cdn.agentdesks.com/images/ISA_ASSETS/Soul_ICA_Danger.png" alt="soul_asset" />
          <BadgeText>Incomplete</BadgeText>
        </Badge>
        <StatusMessage>
          You have to review documents ICA and Exhibits.
        </StatusMessage>
      </StatusDiv>
    </CardV2>
  </ComponentWrap>
)

export default Incomplete
